module.exports = __webpack_public_path__ + "img/copy_btn.2e03992a.png";